import {
  GetSupervisorContactCenter,
  GetOperadorContactCenter,
  PostContactCenter
} from "../../../reducers/contactCenter";

export interface ConfiguracionContactCenterStore
  extends GetSupervisorContactCenter,
    GetOperadorContactCenter,
    PostContactCenter {}

export const configuracionContactCenterStore: (
  state
) => ConfiguracionContactCenterStore = state => {
  const contactCenterState = state.contactCenter;
  return {
    supervisorContactCenter: contactCenterState.supervisorContactCenter,
    gettingSupervisorContactCenter:
      contactCenterState.gettingSupervisorContactCenter,
    gettingSupervisorContactCenterError:
      contactCenterState.gettingSupervisorContactCenterError,
    operadorContactCenter: contactCenterState.operadorContactCenter,
    gettingOperadorContactCenter:
      contactCenterState.gettingOperadorContactCenter,
    gettingOperadorContactCenterError:
      contactCenterState.gettingOperadorContactCenterError,
    postingContactCenter: contactCenterState.postingContactCenter,
    postingContactCenterError: contactCenterState.postingContactCenterError
  };
};
